export default __webpack_public_path__ + "static/media/logo.fcc92302.svg";